// extracted by mini-css-extract-plugin
export default {"TruckMenuItem":"IjHKMymnmWcIKzDm4YEI","TruckMenuItem_content":"Tx2p6ztCBOQBeqbs25pW","TruckMenuItem_photo":"VIjkrZ55GC_BCxspXEMg"};